import { frontEndConstants } from '../constant/front-end-constant';

let musicDirector = JSON.parse(localStorage.getItem('music-director'));
const initialStateNew = musicDirector ? { loggedIn:true, musicDirector:musicDirector, loading:false } : { loggedIn:false, musicDirector:'', loading:false };


export function musicDirectorReducer(state = initialStateNew, action){

	switch(action.type){
		case frontEndConstants.LOGIN_MUSIC_DIRECTOR_REQUEST:
			return { ...state, loading:true };
		case frontEndConstants.LOGIN_MUSIC_DIRECTOR_SUCCESS:
			return {...state, loading:false, musicDirector:action.payload.musicDirector, loggedIn:true};
		case frontEndConstants.LOGIN_MUSIC_DIRECTOR_FAILURE:
			return { loading:false };

		case frontEndConstants.FORGET_MUSIC_DIRECTOR_REQUEST:
			return { ...state, loading:true };
		case frontEndConstants.FORGET_MUSIC_DIRECTOR_SUCCESS:
			return {...state, loading:false};
		case frontEndConstants.FORGET_MUSIC_DIRECTOR_FAILURE:
			return { loading:false };
		
		case frontEndConstants.LOGOUT_MUSIC_DIRECTOR:
			return {};


		case frontEndConstants.GET_ADJUDICATORS_REQUEST:
			return {  ...state, loading:true, adjudicators:[] };
		case frontEndConstants.GET_ADJUDICATORS_SUCCESS:
			return { ...state, loading:false, adjudicators : action.payload.adjudicators };
		case frontEndConstants.GET_ADJUDICATORS_FAILURE:
			return { loading:false, error : action.payload };

		case frontEndConstants.GET_ADJUDICATORS_RECORDINGS_REQUEST:
			return {  ...state, loading:true, recordings:[] };
		case frontEndConstants.GET_ADJUDICATORS_RECORDINGS_SUCCESS:
			return { ...state, loading:false, recordings : action.payload.comments };
		case frontEndConstants.GET_ADJUDICATORS_RECORDINGS_FAILURE:
			return { loading:false, error : action.payload };

		default:

			return {...state};
	}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/MusicDirectorReducer.jsx